export default __webpack_public_path__ + "media/images/icon_done-896f258675535f162fdebdacc5a2d538.svg";